import { component } from 'picoapp';
import Drawer from 'utils/components/drawer';

export default component((node) => {
  const drawer = Drawer(node);

  document.addEventListener('filter:drawer:close', ({ detail }: CustomEvent) => {
    if (detail.id === drawer.container.getAttribute('data-id')) {
      drawer.close();
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    const trigger = target.closest<HTMLElement>('[data-drawer-target]');
    const close = target.closest<HTMLElement>('[data-close]');
    const filterApply = target.closest<HTMLElement>('[data-filter-apply]');

    if (trigger && trigger.dataset.drawerTarget === node.dataset.id) {
      drawer.open();
    }

    if ((close && close.dataset.close === node.dataset.id) || filterApply) {
      drawer.close();
    }
  });

  drawer.on('close', () => {
    const subDrawers = node.querySelectorAll<HTMLElement>('.filter-drawer-item[data-id]');

    subDrawers.forEach((subDrawer) => {
      document.dispatchEvent(new CustomEvent('filter:drawer:close', { detail: { id: subDrawer.getAttribute('data-id') } }));
    });
  });

  const inputs = node.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');
  inputs.forEach((input) => {
    input.addEventListener('change', () => {
      const sameInput = document.querySelector<HTMLInputElement>(`input[id="${input.id.replace('Filter-Drawer', 'Filter')}"][value="${input.value}"]`);

      if (sameInput) {
        sameInput.checked = input.checked;
      }
    });
  });
});
